/*
 * コンサルタント ホットライン 一覧取得
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_PROFESSIONAL_HOTLINE_ALL = 'API_GET_LIST_PROFESSIONAL_HOTLINE_ALL';
export const API_GET_LIST_PROFESSIONAL_HOTLINE_NEW = 'API_GET_LIST_PROFESSIONAL_HOTLINE_NEW';
export const API_GET_LIST_PROFESSIONAL_HOTLINE_SCHEDULED = 'API_GET_LIST_PROFESSIONAL_HOTLINE_SCHEDULED';
/**
 * コンサルタント ホットライン 一覧取得（全部）
 */
export const apiGetListProfessionalHotlineAll = (_, meta) => apiGetList(API_GET_LIST_PROFESSIONAL_HOTLINE_ALL, '/professional/hotline_list', {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
/**
 * コンサルタント ホットライン 一覧取得（新着）
 */
export const apiGetListProfessionalHotlineNew = (_, meta) => apiGetList(API_GET_LIST_PROFESSIONAL_HOTLINE_NEW, '/professional/hotline_new', {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
/**
 * コンサルタント ホットライン 一覧取得（相談予定）
 */
export const apiGetListProfessionalHotlineScheduled = (_, meta) => apiGetList(API_GET_LIST_PROFESSIONAL_HOTLINE_SCHEDULED, '/professional/hotline_scheduled', {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
